import { checkUserCheckout } from 'apis/Api';
import useGlobalModal from 'components/GlobalModal/useGlobalModal';
import useInterval from 'hooks/useInterval';
import { useState, useRef, useEffect } from 'react';
import { dispatchErrorResponse } from 'utils';
import { CHECK_SLIP_STATUS_INTERVAL, RES_CODE_SUCCESS } from '../constants';

const useCheckSlipStatus = () => {
  const { showGlobalModal } = useGlobalModal();
  const [slipStatus, setSlipStatus] = useState<number | null>(null);
  const isMounted = useRef(true);

  // Set up cleanup when component unmounts
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleCheckSlipStatus = async () => {
    try {
      // Skip if component is unmounted
      if (!isMounted.current) return;

      const response = await checkUserCheckout();

      // Check again after async operation completes
      if (!isMounted.current) return;

      if (response.code !== RES_CODE_SUCCESS) {
        dispatchErrorResponse(showGlobalModal, response);
      } else {
        const newSlipStatus = Number(response.slip_sts);
        if (slipStatus !== newSlipStatus && isMounted.current) {
          setSlipStatus(newSlipStatus);
        }
      }
    } catch (error) {
      if (isMounted.current) {
        console.log('error', error);
      }
    }
  };

  // Setup the interval without trying to capture its return value
  useInterval(
    () => {
      handleCheckSlipStatus();
    },
    CHECK_SLIP_STATUS_INTERVAL,
    true
  );

  return slipStatus;
};

export default useCheckSlipStatus;
